"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleOrder = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const SimplePassenger_1 = require("../models/SimplePassenger");
const OrderStatus_1 = require("./OrderStatus");
const PaymentMethod_1 = require("./PaymentMethod");
const SimpleOrderContentLocation_1 = require("./SimpleOrderContentLocation");
const SimpleOrderCustomLocation_1 = require("./SimpleOrderCustomLocation");
let SimpleOrder = class SimpleOrder {
    orderId;
    userId;
    userFullName;
    userEmail;
    price;
    pricingCurrency = legacy_enums_1.Currency.Euro;
    fee;
    isPaid;
    paidAmount;
    status;
    departureAt;
    arrivalAt;
    createdAt;
    vehicles = [];
    simplePassengers = [];
    luggage;
    originLocationName;
    originLocationTimeZone;
    originLocationId;
    destinationLocationName;
    destinationLocationTimeZone;
    destinationLocationId;
    simpleOrderContentLocations = [];
    simpleOrderCustomLocations = [];
    paymentMethod;
    type;
    bundleId;
    assignationOffersCountPerVehicleType;
    airportTransferDirection;
    offerType;
    bookingReference;
};
exports.SimpleOrder = SimpleOrder;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrder.prototype, "orderId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrder.prototype, "userId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrder.prototype, "userFullName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrder.prototype, "userEmail", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SimpleOrder.prototype, "price", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SimpleOrder.prototype, "pricingCurrency", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SimpleOrder.prototype, "fee", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], SimpleOrder.prototype, "isPaid", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SimpleOrder.prototype, "paidAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SimpleOrder.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], SimpleOrder.prototype, "departureAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], SimpleOrder.prototype, "arrivalAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], SimpleOrder.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Array)
], SimpleOrder.prototype, "vehicles", void 0);
__decorate([
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => SimplePassenger_1.SimplePassenger),
    __metadata("design:type", Array)
], SimpleOrder.prototype, "simplePassengers", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Array)
], SimpleOrder.prototype, "luggage", void 0);
__decorate([
    (0, class_validator_1.Length)(1, 64),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrder.prototype, "originLocationName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrder.prototype, "originLocationTimeZone", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrder.prototype, "originLocationId", void 0);
__decorate([
    (0, class_validator_1.Length)(1, 64),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrder.prototype, "destinationLocationName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrder.prototype, "destinationLocationTimeZone", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrder.prototype, "destinationLocationId", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => SimpleOrderContentLocation_1.SimpleOrderContentLocation),
    __metadata("design:type", Array)
], SimpleOrder.prototype, "simpleOrderContentLocations", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => SimpleOrderCustomLocation_1.SimpleOrderCustomLocation),
    __metadata("design:type", Array)
], SimpleOrder.prototype, "simpleOrderCustomLocations", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SimpleOrder.prototype, "paymentMethod", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SimpleOrder.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrder.prototype, "bundleId", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], SimpleOrder.prototype, "assignationOffersCountPerVehicleType", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.AirportTransferDirection),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SimpleOrder.prototype, "airportTransferDirection", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.OfferType),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], SimpleOrder.prototype, "offerType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SimpleOrder.prototype, "bookingReference", void 0);
exports.SimpleOrder = SimpleOrder = __decorate([
    (0, class_transformer_1.Exclude)()
], SimpleOrder);
//# sourceMappingURL=SimpleOrder.js.map